import { LICENSE_LIMIT_CUSTOM_VALUE, LICENSE_UNLIMITED_VALUE } from './licenseConstants';

export function isUnlimitedLimit(value) {
  return value === LICENSE_UNLIMITED_VALUE;
}

export function isPresetLimit(value, presetValues = []) {
  return presetValues.includes(value);
}

export function isCustomLimit(value, presetValues = []) {
  if (value === null || value === undefined || value === '') return false;
  if (isUnlimitedLimit(value)) return false;
  return !isPresetLimit(value, presetValues);
}

export function getLimitSelectValue(value, presetValues = []) {
  if (value === null || value === undefined || value === '') return '';
  if (isUnlimitedLimit(value) || isPresetLimit(value, presetValues)) return value;
  return LICENSE_LIMIT_CUSTOM_VALUE;
}

export function resolveLimitDisplayLabel(value, presetOptions = [], formatCustomLabel) {
  const match = presetOptions.find((option) => option.value === value);
  if (match) return match.label;
  if (isUnlimitedLimit(value)) return 'Unlimited';
  if (value === null || value === undefined || value === '') return '';
  return formatCustomLabel ? formatCustomLabel(value) : String(value);
}

export function validateLimitValue(value, { requiredMessage, invalidMessage } = {}) {
  if (value === null || value === undefined || value === '') {
    return requiredMessage ?? 'Select a limit';
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed) || !Number.isInteger(parsed)) {
    return invalidMessage ?? 'Enter a whole number';
  }

  if (isUnlimitedLimit(parsed)) return null;
  if (parsed < 1) {
    return invalidMessage ?? 'Minimum value is 1';
  }

  return null;
}
